module.exports = __webpack_public_path__ + "static/img/sign-b.3791e3fc.png";